module.exports = "<ion-avatar class=\"circle-icon\" >\n    <img *ngIf=\"icon\" [src]=\"icon\" alt=\"\">\n</ion-avatar>\n"